import React from "react";
import { Box, Typography, Grid, Avatar, Chip, Stack } from "@mui/material";
import { motion } from "framer-motion";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const FEATURES = [
  { icon: "🏦", title: "RBI Registered", desc: "Fully compliant with RBI guidelines for prepaid payment instruments." },
  { icon: "🔐", title: "256-bit SSL", desc: "Your data encrypted end-to-end with bank-grade security protocols." },
  { icon: "⚡", title: "Instant Settlement", desc: "Money moves in real-time. No waiting, no delays, no confusion." },
  { icon: "🎯", title: "Zero Hidden Fees", desc: "What you see is what you pay. Transparent pricing always." },
  { icon: "📱", title: "Always Available", desc: "24/7 access via web and mobile apps. Help center always open." },
  { icon: "🤝", title: "BBPS Certified", desc: "Official Bharat Bill Payment System agent for all utility services." },
];

const TESTIMONIALS = [
  {
    name: "Priya Sharma",
    role: "Small Business Owner, Bengaluru",
    text: "TA Wallet made paying all my business bills so easy. I used to spend hours on each payment. Now it takes minutes.",
    avatar: "P", color: "#16a34a",
  },
  {
    name: "Rahul Mehta",
    role: "IT Professional, Hyderabad",
    text: "The RuPay card integration is seamless. I use it for everything — online shopping, bills, transfers. Best wallet app I have tried.",
    avatar: "R", color: "#0ea5e9",
  },
  {
    name: "Sunita Devi",
    role: "Homemaker, Jaipur",
    text: "Very easy to use. My electricity and gas bills are paid on time every month without any trouble. Highly recommended.",
    avatar: "S", color: "#7c3aed",
  },
];

export default function AllServices() {
  return (
    <>
      {/* Features Grid */}
      <Box sx={{ py: { xs: 8, md: 12 }, px: { xs: 3, md: 8, lg: 12 }, bgcolor: "#f8fafc" }}>
        <Box sx={{ textAlign: "center", mb: { xs: 6, md: 8 } }}>
          <Chip label="Why TA Wallet" sx={{ bgcolor: "#dcfce7", color: "#15803d", fontWeight: 700, fontSize: 12, mb: 2 }} />
          <Typography sx={{ fontSize: { xs: 28, md: 40 }, fontWeight: 900, color: "#0f172a", letterSpacing: "-1px", lineHeight: 1.15 }}>
            Built different,<br />built better
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {FEATURES.map((f, i) => (
            <Grid size={{xs:12, md:4, sm:6}} item xs={12} sm={6} md={4} key={i}>
              <motion.div initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.35, delay: i * 0.07 }}>
                <Box sx={{
                  bgcolor: "white", borderRadius: "18px", p: 3,
                  border: "1.5px solid #f1f5f9",
                  transition: "all 0.2s",
                  "&:hover": { borderColor: "#bbf7d0", boxShadow: "0 8px 32px rgba(22,163,74,0.10)", transform: "translateY(-3px)" },
                }}>
                  <Box sx={{ fontSize: 32, mb: 2 }}>{f.icon}</Box>
                  <Typography sx={{ fontWeight: 800, fontSize: 16, color: "#0f172a", mb: 0.8 }}>{f.title}</Typography>
                  <Typography sx={{ fontSize: 14, color: "#64748b", lineHeight: 1.7 }}>{f.desc}</Typography>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Testimonials */}
     

      {/* Certifications strip */}
      <Box sx={{ py: 4, px: { xs: 3, md: 8, lg: 12 }, bgcolor: "#f8fafc", borderTop: "1px solid #f1f5f9", borderBottom: "1px solid #f1f5f9" }}>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3, justifyContent: "center", alignItems: "center" }}>
          <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#94a3b8", letterSpacing: "1px" }}>CERTIFIED BY</Typography>
          {[
            { src: "/Assets/iso_img_1.jpg", alt: "ISO Certified" },
            { src: "/Assets/Pci_img.png", alt: "PCI DSS" },
            { src: "/Assets/iso_img_2.png", alt: "ISO 27001" },
            { src: "/Assets/Bharat_connect.png", alt: "BBPS" },
          ].map((img) => (
            <Box key={img.alt} component="img" src={img.src} alt={img.alt}
              sx={{ height: 36, opacity: 0.6, filter: "grayscale(20%)", transition: "opacity 0.2s", "&:hover": { opacity: 1 } }}
              onError={(e) => { e.target.style.display = "none"; }}
            />
          ))}
        </Box>
      </Box>
    </>
  );
}
